import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/5 px-4 sm:px-6 lg:px-12 pt-8 pb-6">
      <div className="relative max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <Link to="/admin" data-testid="admin-inbox-trigger-btn" aria-label="Admin login"
          className="group relative inline-flex items-center justify-center rounded-lg border border-white/10 bg-white/[0.03] sm:ml-6 lg:ml-14 p-2.5 text-slate-400 hover:text-amber-300 hover:border-amber-400/40 hover:bg-amber-400/5 transition-all duration-300">
          <Lock className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-rotate-6" />
        </Link>
        <div className="flex-1 flex items-center justify-center sm:absolute sm:left-1/2 sm:-translate-x-1/2">
          <a href="mailto:mandmproductionswa@gmail.com" data-testid="footer-email"
            className="text-xs text-slate-400 hover:text-amber-300 transition-colors duration-300 tracking-wide">
            mandmproductionswa@gmail.com
          </a>
        </div>
        <div className="flex-1 flex justify-center sm:justify-end sm:pr-6 lg:pr-14">
          <p className="text-xs text-slate-600 text-center sm:text-right leading-relaxed" data-testid="footer-copyright">
            © {new Date().getFullYear()} M&M Productions.<br />All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
